import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CalibrationBalance, CalibrationBalanceStatus } from '../../../../model/calibrationBalance';
import { LangFlag, TranslationService } from '../../../../services/translation.service';
import { Subject, takeUntil } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CalibrationEditGenerateReportComponent } from '../../../calibrations/calibration-edit/calibration-edit-generate-report.component';
import { CalibrationBalanceService } from '../../../../services/calibrationBalance.service';
import { InternalEquipmentService } from '../../../../services/internalEquipment.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { InternalEquipment } from '../../../../model/internalEquipment';
import { CalibrationBalanceUtils } from '../../../../utils/calibrationBalanceUtils';
import { saveAs } from 'file-saver';
import { CalibrationBalanceReportFilter } from '../../../../model/attachment';

export interface DialogDataGenerateReport {
  calibration: CalibrationBalance;
  toSign: boolean;
  reason: string;
}

@Component({
  selector: 'app-calibration-balance-edit-generate-report',
  templateUrl: './calibration-balance-edit-generate-report.component.html',
  styleUrl: './calibration-balance-edit-generate-report.component.scss',
  standalone: false
})
export class CalibrationBalanceEditGenerateReportComponent implements OnInit, OnDestroy {

  reportConfig: CalibrationBalanceReportFilter;
  langs: LangFlag[];

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<CalibrationEditGenerateReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataGenerateReport,
    private calibrationService: CalibrationBalanceService,
    private internalEquipmentService: InternalEquipmentService,
    private translate: TranslateService,
    private translationService: TranslationService,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.reportConfig = new CalibrationBalanceReportFilter();
    this.reportConfig.lang = this.translationService.currentLang;
    this.reportConfig.reason = this.data.reason;

    this.langs = this.translationService.configuredLangs;

    if (this.data.calibration.idStatus === CalibrationBalanceStatus.FIRMADO) {
      this.spinnerService.show();

      this.calibrationService.downloadPdfCalibrationVersion(this.data.calibration).pipe(takeUntil(this.destroy$)).subscribe((res: File) => {
        this.downloadFile(this.data.calibration, res);
      }, () => {
        this.snackBarService.sendError(
          this.translate.instant('calibrateEquipmentEdit.dialog.generateReport.form.error.notFound') as string);
        this.spinnerService.hide();
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onOkClick(): void {
    this.spinnerService.show();

    this.reportConfig.toSign = this.data.toSign;
    this.reportConfig.reason = this.data.calibration.reason;

    this.calibrationService.downloadPdf(this.data.calibration.id, this.reportConfig).pipe(takeUntil(this.destroy$))
      .subscribe((res: File) => {
        this.downloadFile(this.data.calibration, res);
      }, () => {
        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.dialog.generateReport.form.error.generic') as string);
        this.spinnerService.hide();
      });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showChangeLangIcon(): boolean {
    return this.langs.length > 1;
  }

  private downloadFile(calibration: CalibrationBalance, file: File) {
    this.internalEquipmentService.findOne(calibration.idEquipment).pipe(takeUntil(this.destroy$))
      .subscribe((equipment: InternalEquipment) => {
        const name = CalibrationBalanceUtils.getNameForCalibration(this.data.calibration, equipment, this.translate);
        saveAs(file, name);
        this.spinnerService.hide();

        this.dialogRef.close();
      });
  }

}
